import { IDs } from '../../../helpers/IDs';
import * as React from 'react';
import { ZaehlerButtonWrapper } from '../assistent/items/wrapper/ZaehlerButtonWrapper';

export function getCustomFormComponent(entity: string, item: any, data: any): any {
    const components: any = {};
    const config: any = {};
    data = data || {};
    item = item || {};

    switch (entity) {
        case IDs.ENT_ENERGIEDATEN_WASSER:
            components.zaehler_tid = (component: any, event: any, callback?:(data: any) => void) => {
                const props: any = component.props || {};
                const state: any = component.state || {};

                return (
                    <ZaehlerButtonWrapper
                        state={(event || {}).stateComponent}
                        data={data}
                        entity={(props.entity || {}).entity}
                        field='zaehler_tid'
                        isFormSaveDone={state.isFormSaveDone}
                        item={state.formValues}
                        layout={props.layout}
                        onChange={props.onChange}
                        reloadBundle={props.reloadBundle}
                    />
                );
            };
            components.zaehler2_tid = (component: any, event: any, callback?:(data: any) => void) => {
                const props: any = component.props || {};
                const state: any = component.state || {};

                if (typeof callback === 'function') {
                    // callback({ state: {} });
                }
                return (
                    <ZaehlerButtonWrapper
                        state={(event || {}).stateComponent}
                        data={data}
                        entity={(props.entity || {}).entity}
                        field='zaehler2_tid'
                        isFormSaveDone={state.isFormSaveDone}
                        item={state.formValues}
                        layout={props.layout}
                        onChange={props.onChange}
                        reloadBundle={props.reloadBundle}
                    />
                );
            };
            break;
    }
    Object.keys(components).forEach((key: string) => config[key] = { custom_component: components[key] });

    return config;
}
